import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Image } from '@outdoor-voices/ui';
import { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { OVContext } from '../../../utils/OVContext';
import css from './Blocks.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
export var Block = function Block(_ref) {
  var image = _ref.image,
      title = _ref.title,
      url = _ref.url;
  return /*#__PURE__*/_jsxs("a", {
    "aria-label": "Click to view ".concat(title.replace('<br>', '')),
    className: css.link,
    href: url,
    children: [/*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
      sizes: [320, 480, 600, 900],
      wrap: false
    })), /*#__PURE__*/_jsx("div", {
      className: css.text,
      children: /*#__PURE__*/_jsx("p", {
        className: css.title,
        dangerouslySetInnerHTML: {
          __html: title
        }
      })
    }), /*#__PURE__*/_jsx("div", {
      className: css.bg,
      "aria-hidden": "true"
    })]
  });
};
Block.propTypes = {
  image: PropTypes.shape(_objectSpread({}, Image.propTypes)).isRequired,
  imageMobile: PropTypes.shape(_objectSpread({}, Image.propTypes)),
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

var Blocks = function Blocks(_ref2) {
  var blocks = _ref2.blocks;

  var _useContext = useContext(OVContext),
      tabletSmall = _useContext.tabletSmall;

  return /*#__PURE__*/_jsx("section", {
    className: css.root,
    children: blocks.map(function (block) {
      return /*#__PURE__*/_createElement(Block, _objectSpread(_objectSpread({}, block), {}, {
        image: tabletSmall ? block.imageMobile : block.image,
        key: block.title
      }));
    })
  });
};

Blocks.propTypes = {
  blocks: PropTypes.arrayOf(PropTypes.shape(_objectSpread({}, Block.propTypes))).isRequired
};
export default /*#__PURE__*/memo(Blocks);